var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16.5C32 25.3366 24.8366 32.5 16 32.5C7.16344 32.5 0 25.3366 0 16.5C0 7.66344 7.16344 0.5 16 0.5C24.8366 0.5 32 7.66344 32 16.5Z",
    fill: "#16A02C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.81 19.475C13.487 19.475 13.1252 19.4683 12.7246 19.4547C12.337 19.4277 11.9041 19.3939 11.426 19.3533V17.4057C11.6845 17.4192 11.9752 17.4395 12.2982 17.4666C12.6342 17.4936 12.9508 17.5072 13.248 17.5072C14.0232 17.5072 14.6822 17.4192 15.2249 17.2434C15.7676 17.0541 16.1811 16.7633 16.4654 16.3711C16.7497 15.9653 16.8918 15.4378 16.8918 14.7886C16.8918 13.8689 16.6011 13.2265 16.0196 12.8613C15.4511 12.4826 14.6176 12.2933 13.5193 12.2933C13.2738 12.2933 12.9701 12.3068 12.6083 12.3339C12.2465 12.3474 11.8524 12.3744 11.426 12.415V10.4269C11.7749 10.3998 12.1044 10.3795 12.4145 10.366C12.7376 10.3525 13.0154 10.3457 13.248 10.3457C14.0878 10.3457 14.8761 10.4201 15.6126 10.5689C16.362 10.7041 17.0146 10.9408 17.5702 11.2789C18.1387 11.617 18.5845 12.0769 18.9076 12.6585C19.2306 13.2265 19.3921 13.9433 19.3921 14.8089C19.3921 15.7827 19.166 16.6213 18.7137 17.3246C18.2615 18.0279 17.6219 18.5621 16.7949 18.9273C15.9679 19.2924 14.973 19.475 13.81 19.475ZM16.4266 25.1149L11.426 19.3533L14.1395 18.6838L19.7604 25.1149H16.4266ZM13.1317 11.9281L13.248 10.3457H20.9233L20.807 11.9281H13.1317ZM11.0771 15.7219L11.2128 14.1394H20.9233L20.807 15.7219H11.0771Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashIcon);
export default __webpack_public_path__ + "static/media/cash_icon.c71e940bfc466581b141da61bfbc3553.svg";
export { ForwardRef as ReactComponent };